import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) {
    console.info('[Sentry] No DSN configured — skipping (set VITE_SENTRY_DSN to enable)')
    return
  }

  Sentry.init({
    dsn,
    environment:   import.meta.env.MODE,
    release:       `the-room-v2@${import.meta.env.VITE_APP_VERSION ?? '0.0.0'}`,
    tracesSampleRate:   0.2,   // 20% of transactions
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  })
}

export function captureError(err: unknown, context?: Record<string, unknown>) {
  console.error('[Error]', err, context)
  Sentry.withScope(scope => {
    if (context) scope.setExtras(context)
    Sentry.captureException(err)
  })
}

export { Sentry }
